<template>
  <h2 class="page-title">
      <icon :name="icon" class="pe-2"></icon>
      <span>{{ title }}</span>
  </h2>
</template>

<script>
import Icon from '@/components/Icon'
export default {
  name: 'page-title',
  props: ['title', 'icon'],
  components: {
    Icon
  }
}
</script>

<style scoped>
  * {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
</style>
